module.exports = __webpack_public_path__ + "img/suggest-learn-orange.4613e80c.png";